import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import JSZip from 'jszip'
// import 'mdi/css/materialdesignicons.css' // Ensure MDI icons are available
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

import { Amplify, Auth } from 'aws-amplify'
import awsExports from './aws-exports'
Amplify.configure(awsExports)
Amplify.configure({
  // OPTIONAL - if your API requires authentication
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: 'eu-west-1:e7333bea-a9ae-465f-8437-fd41c8d74e96',
    // REQUIRED - Amazon Cognito Region
    region: 'eu-west-1',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'eu-west-1_P1f3QIriC',
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: 'u0gr0t4qerbk1si5isji5pm2s',
  },
  API: {
    endpoints: [
      {
        name: 'BadgesAPIGateway',
        endpoint: 'https://jex5foi4v8.execute-api.eu-west-1.amazonaws.com/development',
        // timeout: 180000, // set timeout to 3 minute
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
          }
        },
      },
    ],
  },
})

const zip = new JSZip()
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  icons: {
    iconfont: 'mdi', // Specify MDI as the icon font
  },
  render: h => h(App),
}).$mount('#app')
